<script>
import { mapGetters } from 'vuex';
import FilterChip from './FilterChip.vue';

export default {
  name: 'ReportsFiltersTeams',
  components: { FilterChip },
  emits: ['teamFilterSelection'],
  data() {
    return {
      selectedOption: null,
    };
  },
  computed: {
    ...mapGetters({
      options: 'teams/getTeams',
    }),
  },
  mounted() {
    this.$store.dispatch('teams/get');
  },
  methods: {
    handleInput() {
      this.$emit('teamFilterSelection', this.selectedOption);
    },
  },
};
</script>

<template>
  <FilterChip
    v-model="selectedOption"
    :options="options"
    :placeholder="$t('TEAM_REPORTS.FILTER_DROPDOWN_LABEL')"
    icon="i-lucide-users-round"
    @update:model-value="handleInput"
  />
</template>
